import { Cell, Column, Heading, TimePeriodValue } from "@edgetier/client-components";
import { differenceInSeconds } from "date-fns";
import { FunctionComponent, memo } from "react";
import { IInteraction } from "@edgetier/watchtower-types";
import { IProps } from "./interactions-table-current-handling-time-column.types";
import "./interactions-table-current-handling-time-column.scss";

/**
 * Show the handling time of all handling and completed interactions. This isn't an interaction metric as that is not
 * officially recorded until the interaction finished.
 * @returns Queue time column.
 */
const InteractionsTableCurrentHandlingTimeColumn: FunctionComponent<IProps> = () => {
    return (
        <Column>
            <Heading>Duration</Heading>
            <Cell<IInteraction>>
                {({ exitQueueDateTime, handleDateTime }) => (
                    <TimePeriodValue
                        seconds={
                            exitQueueDateTime instanceof Date
                                ? differenceInSeconds(handleDateTime ?? new Date(), exitQueueDateTime)
                                : null
                        }
                    />
                )}
            </Cell>
        </Column>
    );
};

export default memo(InteractionsTableCurrentHandlingTimeColumn);
